import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { createGlobalStyle } from "styled-components";

const DepositList = () => {
  const location = useLocation();
  const [depositData, setDepositData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/deposits`);
      const resRole = await Http.get(`/staff-type-check`);
      console.log(resRole, "resRole");

      // Helper functions to detect ISO UTC strings and format to desired local display
      // const isIsoUtcDateString = (str) =>
      //   typeof str === "string" &&
      //   /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(str);

      // const formatUtcToLocalDisplay = (isoStr) => {
      //   const d = new Date(isoStr); // parsed as UTC, represented in local time
      //   const months = [
      //     "January",
      //     "February",
      //     "March",
      //     "April",
      //     "May",
      //     "June",
      //     "July",
      //     "August",
      //     "September",
      //     "October",
      //     "November",
      //     "December",
      //   ];
      //   const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
      //   const day = pad2(d.getDate());
      //   const monthName = months[d.getMonth()];
      //   const year = d.getFullYear();
      //   let hours = d.getHours();
      //   const minutes = pad2(d.getMinutes());
      //   const ampm = hours >= 12 ? "PM" : "AM";
      //   hours = hours % 12;
      //   if (hours === 0) hours = 12;
      //   const hh = pad2(hours);
      //   return `${day}-${monthName}-${year} ${hh}:${minutes} ${ampm}`;
      // };

      // Helper to format numeric amount with thousands separators, preserving decimals exactly
      // const formatAmountWithGrouping = (val) => {
      //   if (val === null || val === undefined) return val;
      //   const str = String(val);
      //   if (!/^-?\d+(?:\.\d+)?$/.test(str)) return val; // leave as-is if not a pure number
      //   const isNeg = str.startsWith('-');
      //   const raw = isNeg ? str.slice(1) : str;
      //   const [intPart, decPart] = raw.split('.');
      //   const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      //   const result = decPart !== undefined ? `${grouped}.${decPart}` : grouped;
      //   return isNeg ? `-${result}` : result;
      // };

      // Transform only top-level date fields and 'amount' on each item; preserve all other fields exactly
      // const formattedData = Array.isArray(res.data)
      //   ? res.data.map((item) => {
      //       const formatted = { ...item };
      //       Object.keys(item).forEach((key) => {
      //         const val = item[key];
      //         if (isIsoUtcDateString(val)) {
      //           formatted[key] = formatUtcToLocalDisplay(val);
      //         } else if (key === "amount") {
      //           formatted[key] = formatAmountWithGrouping(val);
      //         }
      //       });
      //       return formatted;
      //     })
      //   : res.data;

      // setDepositData(formattedData);
      setDepositData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log(role, "role");

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "deposit_number", header: "Deposit Number" },
    { field: "bank.name", header: "Bank" },
    { field: "category.name", header: "Category" },
    { field: "amount", header: "Amount" },
    { field: "date", header: "Date" },
    { field: "shop.name", header: "Shop" },
    { field: "staff_detail.name", header: "Staff" },
    { field: "staff.name", header: "Counter" },
    { field: "description", header: "Description" },
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={`/view-deposit/${item.id}`}
          className="btn btn-info btn-sm ms-1"
          title="View Deposit"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>

        {(role === "admin" || role === "accounts") &&
          item.category_id !== null &&
          item.category_id !== 0 && (
            <Link
              to={`/edit-deposit/${item.id}`}
              className="btn btn-primary btn-sm ml-1"
              title="Edit"
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </Link>
          )}
      </td>
    );
  };

  // const statusBodyTemplate = (rowData) => {
  //   return (
  //     <span
  //       className={`badge ${
  //         rowData.status === "active" ? "badge-success" : "badge-danger"
  //       }`}
  //     >
  //       {rowData.status === "active" ? "Active" : "Inactive"}
  //     </span>
  //   );
  // };

  // const amountBodyTemplate = (rowData) => {
  //   return <span>{rowData.amount}</span>;
  // };

  // const dateBodyTemplate = (rowData) => {
  //   return <span>{rowData.date}</span>;
  // };

  // const header = renderHeader();

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Deposits</h5>
            <div className="am-right">
              {(role === "admin" || role == "accounts") && (
                <Link to="/create-deposit" className="btn btn-primary">
                  <i className="fa fa-plus"></i> Add New Deposit
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={depositData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositList;
